<template lang="pug">
div
  template(v-if="!pageLoading")
    .gbox(ref="container")
      #preloader(v-if="gameLaunching")
        #loader
      //- .gbox-menu-wrap
        //- .gbox-menu-wrap-add.justify-content-end
          .gbox-menu-wrap
            .gbox-search.ss-search(@click="toggleSearch")
              .iicon
                img(src='assets/img/search-icon.png')
        //- .gbox-search-box.ss-search-box(:class="{'aaa': showSearch}")
          .search-games
            input.form-control(type='text' v-model="searchinput" placeholder='Search')
          span.search-cancel.ss-search-cancel(@click="cancelSearch") {{$t('ui.cancel')}}
      div.ggl-box(v-if="!pageLoading")
        template(v-if="gameList.length > 0")
          .ggl(v-for="game in gameList")
            template(v-if="game.provider === 'HSD' || game.provider === 'PP-S1'")
              router-link(v-if="isLoggedIn" :to="'/launchOne?provider='+game.provider+'&game=' + game.code" target="_blank")
                img.img-fluid.custom-w(:src='game.img')
                span {{game.game}} 
              a(v-else href="javascript:void(0)" @click="$helpers.openModal('#logModal')")
                img.img-fluid.custom-w(:src='game.img')
                span {{game.game}}
            template(v-else)
              a(href="javascript:void(0)" @click='launchGame(game.code, game.provider, game.category, game.game)')
                img.img-fluid.custom-w(:src='game.img')
                span {{game.game}} 
        //- #end-of-list(v-show='((page !== items.length - 1) || !loading)' ref='end-of-list')
  template(v-else)
    .text-white.my-2.text-center
      i.fas.fa-duotone.fa-spinner.fa-spin-pulse
</template>
<script>
import config from '@/config'
import _ from "lodash";
export default {
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      imageUrl:"",
      page: 0,
      loading: false,
      pageLoading: false,
      gameLaunching:false,
      listToDisplay: [],
      temp:[],
      items:[],
      offList:[],
      // searchinput: "",
      gameList:[
        {game: "Super Ace", provider:"JILI2", code: "49", img:"assets/img/hot/ID_49.png", category:"SLOT"},
        {game: "Golden Empire", provider:"JILI2", code: "103", img:"assets/img/hot/ID_103.png", category:"SLOT"},
        {game: "Money Coming", provider:"JILI2", code: "51", img:"assets/img/game_icon/JILI2/ID_51.jpg", category:"SLOT"},
        {game: "Epic Ace", provider:"EPIC2", code: "40043", img:"assets/img/hot/40043.png", category:"SLOT"},
        {game: "Great Prosperity", provider:"EPIC2", code: "40002", img:"https://epgth.eptech77.com/thumbs/Web/40002.png", category:"SLOT"},
        {game: "Epic Ace Deluxe", provider:"EPIC2", code: "45000", img:"https://epgth.eptech77.com/thumbs/Web/45000.png", category:"SLOT"},
        {game: "Treasure of Aztec", provider:"PG", code: "PG-SLOT-058", img:"assets/img/hot/PG-SLOT-058.png", category:"SLOT"},       
        {game: "Wild Bounty Showdown", provider:"PG", code: "PG-SLOT-105", img:"assets/img/hot/PG-SLOT-105.png", category:"SLOT"},
        {game: "Lucky Neko", provider:"PG", code: "PG-SLOT-065", img:"assets/img/hot/PG-SLOT-065.png", category:"SLOT"},
        // {game: "Maya Golden City 3", provider:"YGR", code: "075", img:"assets/img/game_icon/YGR/075.jpg", category:"SLOT"},
        // {game: "Super Neko", provider:"YGR", code: "078", img:"assets/img/game_icon/YGR/078.jpg", category:"SLOT"},
        {game: "Fortune Gems", provider:"JILI2", code: "109", img:"assets/img/hot/ID_109.png", category:"SLOT"},
        {game: "Super Ace Deluxe", provider:"JILI2", code: "403", img:"assets/img/game_icon/JILI2/ID_403.jpg", category:"SLOT"},
        {game: "3 Coin Treasures", provider:"JILI2", code: "399", img:"assets/img/game_icon/JILI2/ID_399.jpg", category:"SLOT"},
        {game: "Fortune Gems 3", provider:"JILI2", code: "300", img:"assets/img/game_icon/JILI2/ID_300.jpg", category:"SLOT"},
        {game: "Boxing King", provider:"JILI2", code: "77", img:"assets/img/game_icon/JILI2/ID_77.jpg", category:"SLOT"},
        {game: "Crazy 777", provider:"JILI2", code: "35", img:"assets/img/game_icon/JILI2/ID_35.jpg", category:"SLOT"},
        {game: "Color Game", provider:"JILI2", code: "197", img:"assets/img/game_icon/JILI2/ID_197.jpg", category:"TABLE"},
        {game: "Tongits Go", provider:"JILI2", code: "199", img:"assets/img/game_icon/JILI2/ID_199.jpg", category:"TABLE"},
        {game: "Pusoy Go", provider:"JILI2", code: "211", img:"assets/img/game_icon/JILI2/ID_211.jpg", category:"TABLE"},
        {game: "Mines Gold", provider:"JILI2", code: "254", img:"assets/img/hot/mines-gold.png", category:"TABLE"},
        {game: "Go Rush", provider:"JILI2", code: "224", img:"assets/img/hot/go-rush.png", category:"TABLE"},
        {game: "Mines", provider:"JILI2", code: "229", img:"assets/img/hot/mines.png", category:"TABLE"},
        {game: "Mega Fishing", provider:"JILI2", code: "74", img:"assets/img/game_icon/JILI2/ID_74.jpg", category:"FISHING"},
        {game: "Jackpot Fishing", provider:"JILI2", code: "32", img:"assets/img/game_icon/JILI2/ID_32.jpg", category:"FISHING"},
        {game: "Happy Fishing", provider:"JILI2", code: "82", img:"assets/img/game_icon/JILI2/ID_82.jpg", category:"FISHING"},
        {game: "Chinese New Year", provider:"FC", code: "22020", img:"assets/img/hot/22020_200x200_en.png", category:"SLOT"},
        {game: "Lucky Fortunes", provider:"FC", code: "22040", img:"assets/img/hot/22040_200x200_en.png", category:"SLOT"},
        {game: "Night Market", provider:"FC", code: "22018", img:"assets/img/hot/22018_200x200_en.png", category:"SLOT"},
        {game: "Wanted Dead or a Wild", provider:"HSD", code: "HSD_1067", img:"assets/img/hot/HSD_1116.png", category:"SLOT"},
        {game: "Dork Unit", provider:"HSD", code: "HSD_1172", img:"assets/img/hot/HSD_1175.png", category:"SLOT"},
        {game: "Double Rainbow ", provider:"HSD", code: "HSD_1144", img:"assets/img/hot/HSD_1147.png", category:"SLOT"},
        {game: "Gates of Olympus", provider:"PP-S1", code: "PP_vs20olympgate", img:"assets/img/hot/vs20olympgate.png", category:"SLOT"},
        {game: "Sugar Rush", provider:"PP-S1", code: "PP_vs20sugarrush", img:"assets/img/hot/vs20sugarrush.png", category:"SLOT"},
        {game: "Sweet Bonanza", provider:"PP-S1", code: "PP_vs20fruitsw", img:"assets/img/hot/vs20fruitsw.png", category:"SLOT"},
        {game: "iRich Bingo", provider:"JILI2", code: "122", img:"assets/img/hot/ID_122.png", category:"TABLE"},
        {game: "Fortune Bingo", provider:"JILI2", code: "139", img:"assets/img/hot/fortune-bingo.png", category:"BINGO"},
        {game: "Bingo Carnaval", provider:"JILI2", code: "148", img:"assets/img/hot/bingo-carnaval.png", category:"BINGO"},
        {game: "Royal Ace", provider:"YESBINGO", code: "YesBingo-SLOT-022", img:"assets/img/game_icon/YESBINGO/YesBingo-SLOT-022.png", category:"SLOT"},
        {game: "Golden Aztec", provider:"YESBINGO", code: "YesBingo-SLOT-019", img:"assets/img/game_icon/YESBINGO/YesBingo-SLOT-019.png", category:"SLOT"},
        {game: "Fortune Treasure", provider:"YESBINGO", code: "YesBingo-SLOT-001", img:"assets/img/game_icon/YESBINGO/YesBingo-SLOT-001.png", category:"SLOT"},
        {game: "Heat Bingo", provider:"YESBINGO", code: "YesBingo-BINGO-008", img:"assets/img/game_icon/YESBINGO/YesBingo-BINGO-008.png", category:"BINGO"},
        {game: "Money Bingo", provider:"YESBINGO", code: "YesBingo-BINGO-007", img:"assets/img/game_icon/YESBINGO/YesBingo-BINGO-007.png", category:"BINGO"},
        {game: "Open Sesame", provider:"YESBINGO", code: "YesBingo-BINGO-002", img:"assets/img/game_icon/YESBINGO/YesBingo-BINGO-002.png", category:"BINGO"},
      ],
      showSearch: false
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    matchedLocale(){
      switch(this.getLanguage){
        case "en":
          return "en"
        case "ph":
          return "ph"
        default :
          return "en"
      }
    }
  },
  destroyed(){
    window.removeEventListener('scroll', this.loadItems)
  },
  mounted(){
    window.scroll(0,0)
    // this.getProviderGameOfflist()
    // var vm = this
    // window.addEventListener('scroll', this.loadItems)
    // $("*").scroll(function(e) {
    //   vm.loadItems()
    // });
  },
  methods:{
    toggleSearch(){
			this.showSearch = !this.showSearch
		},
		cancelSearch(){
			this.showSearch = false
			this.searchinput = ""
		},	
    // getProviderGameOfflist(){
    //   if (this.sessionToken) {
		// 		var vm = this
    //     let account_id = this.accountID
    //     let auth_token = this.sessionToken
    //     let provider_code = "epic"
    //     this.$store
    //       .dispatch("user/getProviderGameOfflist", { account_id, auth_token, provider_code })
    //       .then(response => {
    //         if (response.success == true) {
		// 					this.offList = response.data
    //           this.getGameList()
    //         } else {             
    //           if((typeof response.status) != 'object'){
    //             this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //           }
    //         }
    //       })
    //       .catch(response => {
    //         if((typeof response.status) != 'object'){
    //           this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //         }
    //       });
    //   }else{
		// 		this.getGameList()
		// 	}
    // },
    // getGameList(){
    //   var vm = this
    //   this.pageLoading = true
		// 	var url = config.getEpicGamelist() + `?lang=${this.matchedLocale}` 
    //   this.$http.get(url).then(
    //     successResponse => {
    //       if(successResponse){
    //         if (typeof successResponse.data.status == "string") {
    //           this.feedback.success = successResponse.status == "200";
    //         } else {
    //           this.feedback.success = successResponse.status == 200;
    //         }
    //         this.feedback.status = successResponse.status;
    //         if (this.feedback.success == true) {             
    //           this.gameList = successResponse.data.Game
    //           this.listToDisplay = [].concat(
    //             this.gameList.filter(obj1 => this.offList.every(obj2 => obj1.GameCode !== obj2.game_id)),
    //             this.offList.filter(obj2 => this.gameList.every(obj1 => obj2.game_id !== obj1.GameCode))
    //           )
    //           const reOrderList = this.gameOrder.map(x => x.id);
    //           const customSort = (item1, item2) => {
    //             const index1 = reOrderList.indexOf(item1.GameCode);
    //             const index2 = reOrderList.indexOf(item2.GameCode);

    //             if (index1 === -1 && index2 === -1) {
    //               // If neither element is in order_array, maintain the original order.
    //               return 0;
    //             } else if (index1 === -1) {
    //               // If only arr1 is not in order_array, move it to the end.
    //               return 1;
    //             } else if (index2 === -1) {
    //               // If only arr2 is not in order_array, move it to the end.
    //               return -1;
    //             }

    //             // Compare the indices in order_array.
    //             return index1 - index2;
    //           };
    //           this.listToDisplay.sort(customSort)
    //           // let updateList = [].concat(
    //           //   this.gameList.filter(obj1 => this.offList.every(obj2 => obj1.GameCode !== obj2.game_id)),
    //           //   this.offList.filter(obj2 => this.gameList.every(obj1 => obj2.game_id !== obj1.GameCode))
    //           // )
    //           // this.items = _.chunk(updateList, 30);
    //           // this.listToDisplay = this.items[0]
    //           this.pageLoading = false
    //         } else {
    //           this.pageLoading = false
    //         }
    //       }else{
    //         this.pageLoading = false
    //       }
    //     },
    //     errorResponse => {
    //       this.pageLoading = false
    //       console.log(errorResponse)
    //     }
    //   );
    // },
    // loadItems(){
    //   if(this.page === this.items.length - 1) return
        
    //   const element = this.$refs["end-of-list"] //this.endOfList;
    //   if(!element) return
      
    //   const position = element.getBoundingClientRect();
    //   // checking whether fully visible
    //   if((position.top >= 0 && position.bottom <= window.innerHeight  ) && !this.loading) {
    //       this.loading = true
    //       this.page++
    //       setTimeout(() => {
    //           this.listToDisplay = (this.listToDisplay).concat(this.items[this.page])
    //           this.loading = false
    //           this.loadItems()
    //       }, 500);
    //   }
    // },
    // launchEpic(code, name){
    //   if (this.sessionToken) {
    //     this.gameLaunching = true
		// 		var vm = this
    //     let player_id = this.accountID
    //     let auth_token = this.sessionToken
    //     let game_code = code
    //     let lang_code = this.matchedLocale
    //     let game_name = name
    //     this.$store
    //       .dispatch("user/launchEpic", { player_id, auth_token,game_code, lang_code, game_name })
    //       .then(response => {
    //         if (response.success == true) {
		// 					setTimeout(() => {
		// 						window.open(response.data, "_blank")
    //             vm.gameLaunching = false
		// 					}) 
    //         } else {     
    //           vm.gameLaunching = false        
    //           if((typeof response.status) != 'object'){
    //             this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //           }
    //         }
    //       })
    //       .catch(response => {
    //         vm.gameLaunching = false
    //         if((typeof response.status) != 'object'){
    //           this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //         }
    //       });
    //   }else{
		// 		$("#logModal").modal("show")
		// 	}
    // },
    launchGame(code, vendor, category, name){
      if (this.sessionToken) {
        this.gameLaunching = true
        var vm = this
        var player_id = this.accountID
        var auth_token = this.sessionToken
        var game_code = code
        var game_name = name
        if(vendor === "EPIC2"){
          let lang_code = this.matchedLocale
          // let game_name = name
          this.$store
            .dispatch("user/launchEpic2", { player_id, auth_token,game_code, lang_code, game_name })
            .then(response => {
              if (response.success == true) {
                setTimeout(() => {
                  window.open(response.data, "_blank")
                  vm.gameLaunching = false
                }) 
              } else {     
                vm.gameLaunching = false        
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {
              vm.gameLaunching = false
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            });
        }else if(vendor === "FC"){
          let lang_code = "en"
          this.$store
            .dispatch("user/launchFc", { player_id, auth_token,game_code, lang_code, game_name})
            .then(response => {
              if (response.success == true) {
                setTimeout(() => {
                  window.open(response.data, "_blank")
                  vm.gameLaunching = false
                }) 
              } else {
                vm.gameLaunching = false        
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {
              vm.gameLaunching = false
              if((typeof response.status) != 'object'){
                if(response.status === 'free_credit_detected'){
                  this.$swal({
                    title: vm.$tc("ui.attention"),
                    text: vm.$tc("message.list.free_credit_detected"),
                    showCancelButton: true,
                    type: "info",
                    confirmButtonText: vm.$tc("ui.ok"),
                    cancelButtonText: vm.$tc("ui.deposit"),
                  }).then(result => {
                    if (result.value) {
                      vm.$router.push({name:"slot",params:{"custom": true}}).catch(error =>{})
                      // 
                    } else if (result.dismiss) {
                      if(result.dismiss === 'cancel'){
                        vm.$router.push("/deposit").catch(error =>{})
                      }
                    }
                  });
                }else{
                  // this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            });
        }else if(vendor === "JILI2"){
          let lang_code = "en"
          this.$store
            .dispatch("user/launchJili", { player_id, auth_token,game_code, lang_code, game_name})
            .then(response => {
              if (response.success == true) {
                setTimeout(() => {
                  window.open(response.data, "_blank")
                  vm.gameLaunching = false
                }) 
              } else {
                vm.gameLaunching = false        
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {
              vm.gameLaunching = false
              if((typeof response.status) != 'object'){
                if(response.status === 'free_credit_detected'){
                  this.$swal({
                    title: vm.$tc("ui.attention"),
                    text: vm.$tc("message.list.free_credit_detected"),
                    showCancelButton: true,
                    type: "info",
                    confirmButtonText: vm.$tc("ui.ok"),
                    cancelButtonText: vm.$tc("ui.deposit"),
                  }).then(result => {
                    if (result.value) {
                      vm.$router.push({name:"slot",params:{"custom": true}}).catch(error =>{})
                      // 
                    } else if (result.dismiss) {
                      if(result.dismiss === 'cancel'){
                        vm.$router.push("/deposit").catch(error =>{})
                      }
                    }
                  });
                }else{
                  // this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            });
        }else if(vendor === "LIVE22"){
          let lang_code = "en"
          this.$store
            .dispatch("user/launchLive22", { player_id, auth_token,game_code, lang_code, game_name})
            .then(response => {
              if (response.success == true) {
                setTimeout(() => {
                  window.open(response.data, "_blank")
                  vm.gameLaunching = false
                }) 
              } else {
                vm.gameLaunching = false        
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {
              vm.gameLaunching = false
              if((typeof response.status) != 'object'){
                if(response.status === 'free_credit_detected'){
                  this.$swal({
                    title: vm.$tc("ui.attention"),
                    text: vm.$tc("message.list.free_credit_detected"),
                    showCancelButton: true,
                    type: "info",
                    confirmButtonText: vm.$tc("ui.ok"),
                    cancelButtonText: vm.$tc("ui.deposit"),
                  }).then(result => {
                    if (result.value) {
                      vm.$router.push({name:"slot",params:{"custom": true}}).catch(error =>{})
                      // 
                    } else if (result.dismiss) {
                      if(result.dismiss === 'cancel'){
                        vm.$router.push("/deposit").catch(error =>{})
                      }
                    }
                  });
                }else{
                  // this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            });
        }else if(vendor === "HSD" || vendor === "PP-S1"){
          let lang_code = "en"
          let provider = vendor
          this.$store
            .dispatch("user/launchLaunchOne", { player_id, auth_token,game_code, lang_code, provider})
            .then(response => {
              if (response.success == true) {
                setTimeout(() => {
                  window.open(response.data, "_blank")
                  vm.gameLaunching = false
                }) 
              } else {
                vm.gameLaunching = false        
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {
              vm.gameLaunching = false
              if((typeof response.status) != 'object'){
                if(response.status === 'free_credit_detected'){
                  this.$swal({
                    title: vm.$tc("ui.attention"),
                    text: vm.$tc("message.list.free_credit_detected"),
                    showCancelButton: true,
                    type: "info",
                    confirmButtonText: vm.$tc("ui.ok"),
                    cancelButtonText: vm.$tc("ui.deposit"),
                  }).then(result => {
                    if (result.value) {
                      vm.$router.push({name:"slot",params:{"custom": true}}).catch(error =>{})
                      // 
                    } else if (result.dismiss) {
                      if(result.dismiss === 'cancel'){
                        vm.$router.push("/deposit").catch(error =>{})
                      }
                    }
                  });
                }else{
                  // this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            });
        }else if(vendor === "PP-S123"){
          let lang_code = "en"
          let provider = vendor
          this.$store
            .dispatch("user/launchPps", { player_id, auth_token,game_code, lang_code, provider})
            .then(response => {
              if (response.success == true) {
                setTimeout(() => {
                  window.open(response.data, "_blank")
                  vm.gameLaunching = false
                }) 
              } else {
                vm.gameLaunching = false        
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {
              vm.gameLaunching = false
              if((typeof response.status) != 'object'){
                if(response.status === 'free_credit_detected'){
                  this.$swal({
                    title: vm.$tc("ui.attention"),
                    text: vm.$tc("message.list.free_credit_detected"),
                    showCancelButton: true,
                    type: "info",
                    confirmButtonText: vm.$tc("ui.ok"),
                    cancelButtonText: vm.$tc("ui.deposit"),
                  }).then(result => {
                    if (result.value) {
                      vm.$router.push({name:"slot",params:{"custom": true}}).catch(error =>{})
                      // 
                    } else if (result.dismiss) {
                      if(result.dismiss === 'cancel'){
                        vm.$router.push("/deposit").catch(error =>{})
                      }
                    }
                  });
                }else{
                  // this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            });
        }else if(vendor === "YGR"){
          let lang_code = "en"
          let provider = vendor
          this.$store
            .dispatch("user/launchYgr", { player_id, auth_token,game_code, lang_code, provider})
            .then(response => {
              if (response.success == true) {
                setTimeout(() => {
                  window.open(response.data, "_blank")
                  vm.gameLaunching = false
                }) 
              } else {
                vm.gameLaunching = false        
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {
              vm.gameLaunching = false
              if((typeof response.status) != 'object'){
                if(response.status === 'free_credit_detected'){
                  this.$swal({
                    title: vm.$tc("ui.attention"),
                    text: vm.$tc("message.list.free_credit_detected"),
                    showCancelButton: true,
                    type: "info",
                    confirmButtonText: vm.$tc("ui.ok"),
                    cancelButtonText: vm.$tc("ui.deposit"),
                  }).then(result => {
                    if (result.value) {
                      vm.$router.push({name:"slot",params:{"custom": true}}).catch(error =>{})
                      // 
                    } else if (result.dismiss) {
                      if(result.dismiss === 'cancel'){
                        vm.$router.push("/deposit").catch(error =>{})
                      }
                    }
                  });
                }else{
                  // this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            });
        }else if(vendor === "PG2" || vendor === "JILI3"){
          let lang_code = "en"
          let provider = vendor
          let game_type = "SLOT"
          let game_name = name
          this.$store
          .dispatch("user/launchOpenapi", { player_id, auth_token,game_code, lang_code, provider, game_type, game_name })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
                vm.gameLaunching = false
							}) 
            } else {
              vm.gameLaunching = false        
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            vm.gameLaunching = false
            if((typeof response.status) != 'object'){
              if(response.status === 'free_credit_detected'){
                this.$swal({
                  title: vm.$tc("ui.attention"),
                  text: vm.$tc("message.list.free_credit_detected"),
                  showCancelButton: true,
                  type: "info",
                  confirmButtonText: vm.$tc("ui.ok"),
                  cancelButtonText: vm.$tc("ui.deposit"),
                }).then(result => {
                  if (result.value) {
                    vm.$router.push("/").catch(error =>{})
                    
                  } else if (result.dismiss) {
                    if(result.dismiss === 'cancel'){
                      vm.$router.push("/deposit").catch(error =>{})
                    }
                  }
                });
              }else{
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                // this.$helpers.showDialog(this.$t("ui.attention"), response.status, "info", this);
              }
            }
          });
        }else{
          let lang_code = "en"
          let provider = vendor
          let game_type = category
          this.$store
            .dispatch("user/launchAwc", { player_id, auth_token,game_code, lang_code, provider, game_type, game_name })
            .then(response => {
              if (response.success == true) {
                setTimeout(() => {
                  window.open(response.data, "_blank")
                  vm.gameLaunching = false
                }) 
              } else {
                vm.gameLaunching = false        
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {
              vm.gameLaunching = false
              if((typeof response.status) != 'object'){
                if(response.status === 'free_credit_detected'){
                  this.$swal({
                    title: vm.$tc("ui.attention"),
                    text: vm.$tc("message.list.free_credit_detected"),
                    showCancelButton: true,
                    type: "info",
                    confirmButtonText: vm.$tc("ui.ok"),
                    cancelButtonText: vm.$tc("ui.deposit"),
                  }).then(result => {
                    if (result.value) {
                      vm.$router.push({name:"slot",params:{"custom": true}}).catch(error =>{})
                      
                    } else if (result.dismiss) {
                      if(result.dismiss === 'cancel'){
                        vm.$router.push("/deposit").catch(error =>{})
                      }
                    }
                  });
                }else{
                  // this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            });
        }
        
      }else{
				$("#logModal").modal("show")
			}
    },
    filteredList(){
      return this.gameList.filter((game) =>
        game.game.toLowerCase().includes(this.searchinput.toLowerCase())
      );
    }
  }
}
</script>